import React from 'react';
import { RAIL_TOP } from './tokens';

/**
 * Desktop right rail. Sticky at 92px (TopBar 68 + 24 breathing room). With `scroll` it
 * caps at the viewport and scrolls on its own — so an infinite feed can never push it under
 * the header — with `overscroll-behavior: contain` so it doesn't chain to the page.
 */
export default function StickyRail({ width = 380, top = RAIL_TOP, scroll = false, className = '', children, testId = 'sticky-rail' }) {
  return (
    <div
      className={`flex flex-none flex-col gap-3 self-start ${scroll ? '[&::-webkit-scrollbar]:hidden' : ''} ${className}`}
      style={{
        width,
        position: 'sticky',
        top,
        ...(scroll ? { maxHeight: `calc(100vh - ${top + 16}px)`, overflowY: 'auto', overscrollBehavior: 'contain', scrollbarWidth: 'none' } : {}),
      }}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
